<template>
    <div>
        <div style="
        width:100%;
        justify-content: center;
        page-break-after: always;
        box-sizing:border-box;
        padding: 20px;
        "
        class="page"
        v-for="(order, page_index) in printData" :key="'page_' + page_index"
        >
            <div style="display:flex;width:100%;min-height:220mm">
                <table style="width:100%;border-collapse: collapse">
                    <thead>
                        <tr style="padding-bottom:10px">
                            <th colspan="8">
                                <div style="display:flex;width:100%">
                                    <div style="display:inline-flex;flex-basis:50%;flex-direction:column">
                                        <div style="display:flex;">
                                            <div style="display:inline-flex;">
                                                <img :src="company.profile" alt="" style="max-height:100px;max-width:100px">
                                            </div>
                                            <div style="display:inline-flex;flex-direction:column;margin-left:10px">
                                                <div style="display:flex;font-weight:900;font-size:18px;text-align:left">{{ company.name }}</div>
                                                <div style="display:flex;font-size:14px">สำนักงานใหญ่</div>
                                                <div style="display:flex;font-size:14px;text-align:left">{{ company.address }} {{ company.city }} {{ company.county }} {{ company.province }} {{ company.postcode }}</div>
                                                <div style="display:flex;font-size:14px;text-align:left">{{ company.tel }}</div>
                                                <div style="display:flex;font-size:14px;text-align:left">เลขประจำตัวผู้เสียภาษี {{ company.taxid }}</div>
                                            </div>
                                        </div>
                                        <div style="display:flex;font-weight:800;font-size:18px;width:100%;margin-top:10px">
                                            ผู้ขาย
                                        </div>
                                        <div style="display:inline-flex;flex-direction:column">
                                            <div style="display:flex;font-weight:900;font-size:16px;text-align:left">{{ order.supplierName }}</div>
                                            <div style="display:flex;font-size:14px;text-align:left">{{ order.supplierAddress }}</div>
                                            <div style="display:flex;font-size:14px;text-align:left" v-if="order.supplierTaxNo">เลขประจำตัวผู้เสียภาษี {{ order.supplierTaxNo }}</div>
                                        </div>
                                    </div>
                                    <div style="display:inline-flex;flex-basis:50%;flex-direction:column">
                                        <div style="display:flex;width:100%;border-bottom:1px solid black;width:100%;flex-direction:column">
                                            <div style="display:flex;justify-content: flex-end;font-size:24px;font-weight:bold">ใบสั่งของ</div>
                                            <div style="display:flex;justify-content: flex-end;font-size:20px;padding-top:10px;padding-bottom:10px">ต้นฉบับ (เอกสารออกเป็นชุด)</div>
                                        </div>
                                        <div style="display:flex;flex-direction:column;width:100%;margin-top:10px">
                                            <div style="display:flex">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">เลขที่</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.orderNumber }}</div>
                                            </div>
                                            <div style="display:flex">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">วันที่</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.createdAt }}</div>
                                            </div>
                                            <div style="display:flex">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">เข้าคลัง</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.warehouseName }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr style="">
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:5%">#</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:10%">รูป</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:20%">ชื่อสินค้า</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:15%">
                                <div>ราคา/หน่วย</div>
                                <div style="font-size:12px">รวมภาษีมูลค่าเพิ่ม</div>
                            </th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:10%">ส่วนลด</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:10%">จำนวน</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:15%">
                                <div>ราคารวม</div>
                                <div style="font-size:12px">หลังหักส่วนลด</div>
                            </th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:15%">
                                <div>VAT</div>
                                <div style="font-size:12px">ภาษีมูลค่าเพิ่ม</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product,index) in order.orderItems" :key="'product_' + index">
                            <td style="text-align:center">{{ index + 1 }}</td>
                            <td style="text-align:center">
                                <img :src="product.imageURL" alt="" style="max-width:100px;max-height:100px">
                            </td>
                            <td>
                                {{ product.name }}
                                <div style="opacity:0.8;font-size:14px">{{ product.sku }}</div>
                                <div style="font-size:14px" v-if="product.note">
                                    หมายเหตุ : {{ product.note }}
                                </div>
                            </td>
                            <td style="text-align:right">{{ product.price }}</td>
                            <td style="text-align:right">{{ product.discount ? (product.discount_type == 'percent' ? product.discount + '%' : product.discount) : 0 }}</td>
                            <td style="text-align:right">{{ product.quantity }} {{ product.unit }}</td>
                            <td style="text-align:right">{{ product.priceSum | formatNumber }}</td>
                            <td style="text-align:right">
                                {{ (order.VAT && product.VAT ? product.VATInValue : 0) | formatNumber }}
                            </td>
                        </tr>
                        <template v-if="5 - order.orderItems.length > 0">
                            <tr v-for="pd in 5 - order.orderItems.length" :key="'temp_' + pd">
                                <td colspan="8" style="padding-top:50px;padding-bottom:50px"></td>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="8">
                                <div style="display:flex;width:100%;page-break-inside:avoid;flex-direction:column;margin-top:auto">
                                <div style="display:flex;width:100%;border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px"></div>
                                <div style="display:flex;width:100%">
                                    <div style="display:inline-flex;width:35%">
                                        หมายเหตุ : {{ order.note }}
                                    </div>
                                    <div style="display:inline-flex;width:35%;flex-direction:column">
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            รวมเป็นเงิน
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            ส่วนลดทั้งบิล
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            จำนวนเงินหลักหักส่วนลด
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center;border-bottom:1px solid black">
                                            ค่าจัดส่ง
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            ภาษีมูลค่าเพิ่ม {{ order.VAT }} %
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center;border-bottom:1px solid black">
                                            ราคาก่อนภาษีมูลค่าเพิ่ม
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            (รวมภาษีมูลค่าเพิ่ม) รวม
                                        </div>
                                        <div style="display:flex;border-bottom:1px solid black"></div>
                                        <div style="display:flex;border-bottom:2px solid black;padding-top:2px;"></div>
                                    </div>
                                    <div style="display:inline-flex;width:30%;flex-direction:column">
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            {{ order.priceBeforeDiscount | formatNumber }}
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            {{ order.discount ? (order.discount_type == 'percent' ? order.discount + '%' : order.discount) : 0 }}
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            {{ order.priceAfterDiscount | formatNumber }}
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center;border-bottom:1px solid black">
                                            {{ order.delivery_cost }}
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            {{ order.VATSum | formatNumber}}
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center;border-bottom:1px solid black">
                                            {{ order.priceBeforeVAT | formatNumber}}
                                        </div>
                                        <div style="display:flex;justify-content: flex-end;height:30px;align-items:center">
                                            {{ order.totalPrice | formatNumber}}
                                        </div>
                                        <div style="display:flex;border-bottom:1px solid black"></div>
                                        <div style="display:flex;border-bottom:2px solid black;padding-top:2px;"></div>
                                    </div>
                                </div>
                            </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { convertDateTomeToAooDefault } from '@/helpers/converter'
export default {
  props: {
    printData: {
      required: true,
      default: [],
    },
    company: {
      required: true,
      default: {},
    },
  },
  data() {
    return {
      printDate: convertDateTomeToAooDefault(new Date()),
    }
  },
}
</script>
